import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  manageAccess: {
    id: 'manageAccess',
    defaultMessage: 'Manage access rules',
  },
  selectedTitle: {
    id: 'selectedTitle',
    defaultMessage: 'Selected',
  },
  selectAll: {
    id: 'selectAll',
    defaultMessage: 'Select all',
  },
  searchResults: {
    id: 'searchResults',
    defaultMessage: 'Search results',
  },
  searchUserPlaceholder: {
    id: 'searchUserPlaceholder',
    defaultMessage: 'Search by user name or email',
  },
  saveRulesChanges: {
    id: 'saveRulesChanges',
    defaultMessage: 'Save changes',
  },
  noMatches: {
    id: 'noMatches',
    defaultMessage: 'No matches',
  },
  accessRights: {
    id: 'accessRights',
    defaultMessage: 'Access rights',
  },
  view: {
    id: 'view',
    defaultMessage: 'View',
  },
  sign: {
    id: 'sign',
    defaultMessage: 'Sign',
  },
  execute: {
    id: 'execute',
    defaultMessage: 'Execute',
  },
});

export default { ...globalIntl, ...m };
